module.exports = __webpack_public_path__ + "static/media/school-kids.66a5aacf.jpg";